module.exports = __webpack_public_path__ + "svg/round-angle.svg?c1eeaef65e8c9df527540158e9be5df1";